export default __webpack_public_path__ + "static/media/present.833921b9.wav";